module.exports = __webpack_public_path__ + "img/img2.2571ac74.png";